// Module
var code = `<selectable-list columns="\$ctrl.columns"
                 selectable-column-label="Mark checks to transfer"
                 records-per-page="50"
                 get-records-page="\$ctrl.getChecksOnCurrentPage(pageSettings)"
                 on-change="\$ctrl.onCheckChange({ checkedRecords })">
</selectable-list>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/check-list-wrapper/check-list-wrapper.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;